<template lang="html">
  <div v-if="!isLoggedIn" class="unauthorized" :class="{ 'unauthorized--dusk': isAboutPage }">
    <div
      class="unauthorized__wrapper"
      :class="{ 'slide-in': isOpen, 'slide-out': !isOpen }"
    >
      <div class="container">
        <div class="unauthorized__content">
          <div class="unauthorized__logo-small">
            <router-link :to="vueRoutes.about" class="unauthorized__logo-link">
              <img
                src="@/assets/branding/logo/unauthorized-logo-small.png"
                class="unauthorized__logo-img"
                alt="m2RWA logo"
              />
            </router-link>
          </div>
          <div class="unauthorized__nav-panel-outer">
            <div class="unauthorized__nav-panel">
              <div class="unauthorized__nav-panel-wrp">
                <router-link
                  class="unauthorized__nav-panel-link"
                  active-class="unauthorized__nav-panel-link-active"
                  :to="vueRoutes.about"
                >
                  {{ $t('settings.nav-bar.about') }}
                </router-link>
              </div>

              <div class="unauthorized__nav-panel-wrp">
                <router-link
                  class="unauthorized__nav-panel-link"
                  active-class="unauthorized__nav-panel-link-active"
                  :to="vueRoutes.marketplace"
                >
                  {{ $t('settings.nav-bar.marketplace') }}
                </router-link>
              </div>

              <div class="unauthorized__nav-panel-wrp">
                <router-link
                  class="unauthorized__nav-panel-link"
                  active-class="unauthorized__nav-panel-link-active"
                  :to="vueRoutes.rentMarketplace"
                >
                  <span class="unauthorized__label-full">{{ $t('settings.nav-bar.rent') }}</span>
                  <span class="unauthorized__label-short">{{ $t('settings.nav-bar.rent-short') }}</span>
                </router-link>
              </div>

              <div class="unauthorized__nav-panel-wrp">
                <router-link
                  class="unauthorized__nav-panel-link"
                  active-class="unauthorized__nav-panel-link-active"
                  :to="vueRoutes.exchange"
                >
                  <span class="unauthorized__label-full">{{ $t('settings.nav-bar.exchange') }}</span>
                  <span class="unauthorized__label-short">{{ $t('settings.nav-bar.exchange-short') }}</span>
                </router-link>
              </div>

              <div class="unauthorized__nav-panel-wrp">
                <router-link
                  class="unauthorized__nav-panel-link"
                  active-class="unauthorized__nav-panel-link-active"
                  :to="vueRoutes.dao"
                >
                  <span class="unauthorized__label-full">{{ $t('settings.nav-bar.dao') }}</span>
                  <span class="unauthorized__label-short">{{ $t('settings.nav-bar.dao-short') }}</span>
                </router-link>
              </div>

              <div class="unauthorized__nav-panel-wrp">
                <router-link
                  class="unauthorized__nav-panel-link"
                  active-class="unauthorized__nav-panel-link-active"
                  :to="vueRoutes.FAQ"
                >
                  {{ $t('settings.nav-bar.faq-link') }}
                </router-link>
              </div>
              <div class="unauthorized__nav-panel-wrp">
                <router-link
                  class="unauthorized__nav-panel-link"
                  active-class="unauthorized__nav-panel-link-active"
                  :to="vueRoutes.contacts"
                >
                  {{ $t('settings.nav-bar.contacts') }}
                </router-link>
              </div>
              <div class="unauthorized__re-tokens">
<!--                <div class="unauthorized__re-tokens-item">-->
<!--                  <div class="unauthorized__re-tokens-title">-->
<!--                    {{ $t('re-tokens.amount') }}-->
<!--                  </div>-->
<!--                  <div class="unauthorized__re-tokens-balance">-->
<!--                    {{ formattedTotalRe }}-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="unauthorized__re-tokens-item">-->
<!--                  <div class="unauthorized__re-tokens-title">-->
<!--                    {{ $t('re-tokens.for-buy') }}-->
<!--                  </div>-->
<!--                  <div class="unauthorized__re-tokens-balance">-->
<!--                    {{ formattedRE  }}-->
<!--                  </div>-->
<!--                </div>-->
                <ReTokens :is-header="true"/>
              </div>
            </div>
          </div>
          <div class="unauthorized__switcher-wrp">
            <language-switcher />
            <router-link class="unauthorized__login" :to="vueRoutes.login">
              <div class="unauthorized__login-text">
                {{ $t('unauthorized.login') }}
              </div>
              <div class="unauthorized-image-login">
                <icon :name="'unauthorized-login'" />
              </div>
              <div class="unauthorized-image-entry">
                <icon :name="'unauthorized-entry'" />
              </div>
            </router-link>
          </div>
          <div class="unauthorized__nav-panel-mobile">
            <BurgerMenu @is-open="isOpen = !isOpen">
              <div class="unauthorized__nav-panel-wrp">
                <router-link
                  class="unauthorized__nav-panel-link"
                  active-class="unauthorized__nav-panel-link-active"
                  :to="vueRoutes.about"
                >
                  {{ $t('settings.nav-bar.about') }}
                </router-link>
              </div>

              <div class="unauthorized__nav-panel-wrp">
                <router-link
                  class="unauthorized__nav-panel-link"
                  active-class="unauthorized__nav-panel-link-active"
                  :to="vueRoutes.marketplace"
                >
                  {{ $t('settings.nav-bar.marketplace') }}
                </router-link>
              </div>

              <div class="unauthorized__nav-panel-wrp">
                <router-link
                  class="unauthorized__nav-panel-link"
                  active-class="unauthorized__nav-panel-link-active"
                  :to="vueRoutes.rentMarketplace"
                >
                  {{ $t('settings.nav-bar.rent') }}
                </router-link>
              </div>

              <div class="unauthorized__nav-panel-wrp">
                <router-link
                  class="unauthorized__nav-panel-link"
                  active-class="unauthorized__nav-panel-link-active"
                  :to="vueRoutes.exchange"
                >
                  {{ $t('settings.nav-bar.exchange') }}
                </router-link>
              </div>

              <div class="unauthorized__nav-panel-wrp">
                <router-link
                  class="unauthorized__nav-panel-link"
                  active-class="unauthorized__nav-panel-link-active"
                  :to="vueRoutes.dao"
                >
                  {{ $t('settings.nav-bar.dao') }}
                </router-link>
              </div>

              <div class="unauthorized__nav-panel-wrp">
                <router-link
                  class="unauthorized__nav-panel-link"
                  active-class="unauthorized__nav-panel-link-active"
                  :to="vueRoutes.FAQ"
                >
                  {{ $t('settings.nav-bar.faq-link') }}
                </router-link>
              </div>
              <div class="unauthorized__nav-panel-wrp">
                <router-link
                  class="unauthorized__nav-panel-link"
                  active-class="unauthorized__nav-panel-link-active"
                  :to="vueRoutes.contacts"
                >
                  {{ $t('settings.nav-bar.contacts') }}
                </router-link>
              </div>
              <div class="unauthorized__re-tokens unauthorized__re-tokens-burger">
<!--                <div class="unauthorized__re-tokens-item unauthorized__re-tokens-item-burger">-->
<!--                  <div class="unauthorized__re-tokens-title">-->
<!--                    {{ $t('re-tokens.amount') }}-->
<!--                  </div>-->
<!--                  <div class="unauthorized__re-tokens-balance">-->
<!--                    {{ formattedTotalRe }}-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="unauthorized__re-tokens-item unauthorized__re-tokens-item-burger">-->
<!--                  <div class="unauthorized__re-tokens-title">-->
<!--                    {{ $t('re-tokens.for-buy') }}-->
<!--                  </div>-->
<!--                  <div class="unauthorized__re-tokens-balance">-->
<!--                    {{ formattedRE }}-->
<!--                  </div>-->
<!--                </div>-->
                <ReTokens />
              </div>
              <template #footer>
                <div class="unauthorized__switcher-wrp-mobile">
                  <language-switcher color="#196DEA" />
                  <router-link
                    class="unauthorized__login"
                    :to="vueRoutes.login"
                  >
                    <div class="unauthorized-image-login">
                      <icon :name="'unauthorized-login-mobile'" />
                    </div>
                    <div class="unauthorized__login-text">
                      {{ $t('unauthorized.login') }}
                    </div>
                  </router-link>
                </div>
              </template>
            </BurgerMenu>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import BurgerMenu from '@/vue/components/common/BurgerMenu.vue';
import icon from '@/vue/components/common/Icon.vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { computed } from 'vue';
import { languageSwitcher } from '@/js/helpers/languageSwitcher';
import LanguageSwitcher from '@/vue/components/common/LanguageSwitcher.vue';
import { vueRoutes } from '@/router/router-const';
import {formatBalanceRE} from "@/js/filters/formatBalance";
import ReTokens from "@/vue/components/common/ReTokens.vue";
export default {
  name: 'UnauthorizedPanel',
  components: {
    icon,
    LanguageSwitcher,
    BurgerMenu,
    ReTokens,
  },
  setup() {
    const isOpen = ref(false);
    const store = useStore();
    const route = useRoute();
    const isLoggedIn = computed(() => store.getters['auth/isLoggedIn']);
    const isAboutPage = computed(() => route.name === vueRoutes.about.name);
    const formattedRE = computed(() => {
      const balanceRE = store.getters['balances/getBalances'].balanceRE;
      return formatBalanceRE(balanceRE);
    });
    const formattedTotalRe = computed(() => {
      const balanceRE = store.getters['balances/getBalances'].balanceRE;
      return formatBalanceRE(balanceRE);
    });

    return { languageSwitcher, isLoggedIn, isAboutPage, vueRoutes, isOpen, formattedRE, formattedTotalRe };
  },
};
</script>
<style lang="scss" scoped>
@import '@/scss/variables.scss';
@import '@/scss/app.scss';

// Guest header widths, measured in Chrome and Safari with the UA labels (the longest):
// - full link labels together with the token tiles need 1770px;
// - short labels («Оренда», «DAO») with the tiles need 1550px;
// - short labels without the tiles fit down to 1101px once the header margins are dropped;
// - below that the links (and the tiles) move into the burger menu.
// Each threshold keeps ~30px in reserve for longer token figures.
$guest-full-labels-min: 1860px; // measured 1850 with the «Біржа» link (2026-10-13)
$guest-tiles-min: 1640px; // measured 1630
$guest-compact-bp: 1200px;
$guest-nav-bp: 1100px;

.unauthorized {
  background-color: #1e3a5f;
  width: 100%;
  position: fixed;
  top: 0;
  height: 9rem;
  z-index: $z-index-unauthorized-panel;
  &__language {
    display: flex;
  }
  &__wrapper {
    height: 100%;
    margin: 0 calc($sidebar-width / 2);
    display: flex;
    align-items: center;

    @include respond-to($guest-compact-bp) {
      margin: 0;
    }
  }

  &__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &__logo {
    display: inline-flex;
  }

  &__login {
    min-width: 10rem;
    background-color: #f4f4f4;
    border-radius: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0.5rem;
    color: #333333;
    font-size: 1.5rem;
    transition: all 0.3s;

    @include respond-to($guest-nav-bp) {
      background-color: unset;
      border-radius: 0;
    }

    &-image {
      display: none;
    }

    &-text {
      margin: 0 0.6rem 0 0;
      @include respond-to($guest-nav-bp) {
        color: #196dea;
        display: flex;
        align-items: center;
        margin: 0 0 0 0.6rem;
      }
    }

    &:hover {
      color: #196dea;
      background-color: #fff;

      .unauthorized-image-login {
        stroke: #196dea;
      }
    }
  }

  &-image {
    &-login {
      display: flex;
      stroke: #333333;
      transition: all 0.3s;
    }
    &-entry {
      display: none;
      @include respond-to($small) {
        display: block;
        width: 25px;
        height: 25px;
      }
    }
  }
}
.unauthorized__logo-img {
  object-fit: contain;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  image-rendering: optimizeQuality;
  height: 16rem;
  width: 16rem;
  display: block;
  @include respond-to($guest-nav-bp) {
    height: 11rem;
    width: 11rem;
  }
}
.unauthorized__logo-small {
  width: 16rem;
  flex-shrink: 0;
  overflow: visible;
  position: relative;
  z-index: 1;
  @include respond-to($guest-nav-bp) {
    width: 11rem;
  }
}
.unauthorized__logo-link {
  display: block;
  line-height: 0;
}
.unauthorized__logo {
  display: flex;
  justify-content: center;
  align-items: center;
}
.unauthorized__nav-panel-mobile {
  display: none;
  @include respond-to($guest-nav-bp) {
    display: block;
  }
}
.unauthorized__nav-panel {
  gap: clamp(1.6rem, 1.6vw, 3rem);
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  white-space: nowrap; /* Предотвращает перенос текста на новую строку */
  //margin: 0 3rem;
  overflow: hidden;
  @include respond-to($guest-compact-bp) {
    gap: 1.5rem;
  }
  @include respond-to($guest-nav-bp) {
    display: none;
  }
}
.unauthorized__nav-panel-wrp {

}
.unauthorized__label-full,
.unauthorized__label-short {
  // app.scss sets every span to 1.4rem; the label must keep the link's size
  font-size: inherit;
}
.unauthorized__label-short {
  display: none;
}
@include respond-to($guest-full-labels-min - 1px) {
  .unauthorized__label-full {
    display: none;
  }
  .unauthorized__label-short {
    display: inline;
  }
}
// the token tiles are also in the burger menu, so on narrower screens the row simply drops them
.unauthorized__nav-panel > .unauthorized__re-tokens {
  @include respond-to($guest-tiles-min - 1px) {
    display: none;
  }
}
.unauthorized__nav-panel-link {
  font-size: 1.6rem;

  @include respond-to($guest-nav-bp) {
    color: $col-mobile-burger;
    font-size: 2.2rem;
    padding: 0 4rem;
    display: flex;
    align-items: center;
    height: 7rem;
  }
}
.unauthorized__nav-panel-link-active {
  @include respond-to($guest-nav-bp) {
    background-color: $col-select;

    /* align-items: center; */
    display: flex;
    align-items: center;
    color: $col-primary;
  }
}
.unauthorized__switcher-wrp {
  display: flex;
  gap: 2rem;
  @include respond-to($guest-nav-bp) {
    display: none;
  }
}
.unauthorized__switcher-wrp-mobile {
  @include respond-to($guest-nav-bp) {
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom: 0;
    padding: 0 4rem 6rem 4rem;
    width: 100%;
  }
  @media (max-height: 720px) {
      position: unset;
      margin-top: 2rem;
    }
}

.unauthorized__logo-text {
  @include respond-to($x-small) {
    width: 7rem;
  }
}
img:not(.unauthorized__logo-img) {
  height: fit-content;
}
.slide-in {
  @include respond-to($guest-nav-bp) {
    animation: slideIn 0.7s forwards !important;
  }
}
.slide-out {
  @include respond-to($guest-nav-bp) {
    animation: slideOut 0.7s forwards !important;
  }
}

@keyframes slideIn {
  from {
    background-color: $_oceanBlue;
  }
  to {
    background-color: $bg-mobile-burger;
    border-bottom: 1px solid #bfcbd8;
  }
}

@keyframes slideOut {
  from {
    background-color: $bg-mobile-burger;
  }
  to {
    background-color: $_oceanBlue;
  }
}

.unauthorized__re-tokens {
  display: flex;
  gap: 2rem;
}
.unauthorized__re-tokens-item {
  border-left: 1px solid #196DEA;
  border-radius: 6px;
  background-color: white;
  flex: 1 0 0;
  padding: 0.6rem 1rem;
}
.unauthorized__re-tokens-title{
  white-space: nowrap;
  color: #858585;
  font-feature-settings: 'clig' off, 'liga' off;
  font-size: 10px;
  font-weight: 400;
  line-height: normal;
  letter-spacing: -0.15px;
}
.unauthorized__re-tokens-balance {
  color: #333;
  font-size: 16px;
  font-weight: 400;
}
//.unauthorized__re-tokens-item-burger {
//  border-radius: 0;
//}
.unauthorized__re-tokens-burger {
  flex-direction: column;
  gap: 2rem;
  margin: 4rem 4rem;
}
.unauthorized__nav-panel-outer {
  overflow-x: auto;
  margin: 0 3rem;
}
// The start page is dark and gold from the top edge down.
.unauthorized--dusk {
  background: linear-gradient(180deg, rgba(8, 7, 6, 0.7), rgba(8, 7, 6, 0.28));
  border-bottom: 1px solid rgba(217, 168, 78, 0.16);
  backdrop-filter: blur(10px);

  .unauthorized__wrapper.slide-out {
    animation: none !important;
  }

  .unauthorized__nav-panel-link {
    color: #f6f0e4;

    &:hover {
      color: #f7dc97;
    }
  }

  .unauthorized__nav-panel .router-link-active {
    color: #f7dc97;
  }

  .unauthorized__login {
    background: linear-gradient(180deg, #f6d68b, #c98f2e);

    &:hover {
      background: linear-gradient(180deg, #fbe3a8, #d9a03e);
    }
  }
}
</style>
